class PreLoader {
    constructor(_staticPath, _loadCompleteCallback){

        this.imgURLArr =  [
            _staticPath + '/img/aside/nav_map_bg_pc.png',
            _staticPath + '/img/gate/title_pc.png',
            _staticPath + '/img/banquet/title_pc.png',
            _staticPath + '/img/banquet/btn_tribute_pc.png',
            _staticPath + '/img/banquet/btn_keynote_replay_pc.png',
            _staticPath + '/img/ic_loading_on.png',
            _staticPath + '/img/aside/nav_menu_preorder_pc.png',
            _staticPath + '/img/ic_loading.png',
            _staticPath + '/img/aside/nav_menu_home_pc.png',
            _staticPath + '/img/gate/btn_general_pc.png',
            _staticPath + '/img/garden/reward_item_icon3.png',
            _staticPath + '/img/garden/reward_item_icon2.png',
            _staticPath + '/img/garden/reward_item_icon1.png',
            _staticPath + '/img/btn_spot1.png',
            _staticPath + '/img/btn_spot2.png',
            _staticPath + '/img/aside/nav_pc.png',
            _staticPath + '/img/aside/nav_map_list_bg_pc.png',
            _staticPath + '/img/layer_drag_pc.png',
            _staticPath + '/img/living/event_banner_1_pc.png',
            _staticPath + '/img/living/event_banner_1.png',
            _staticPath + '/img/aside/nav_frame_pc.png',
            _staticPath + '/img/aside/nav_close_pc.png',
            _staticPath + '/img/aside/nav_bullet_pc.png',
            _staticPath + '/img/aside/nav_top_pc.png',
            _staticPath + '/img/util_top_pc.png',
            _staticPath + '/img/banquet/btn_keynote_pc.png',
            _staticPath + '/img/gate/cover_pc.png',
        ];
        
        this.loadingIndex = 0;
        this.loadFailNum = 0;
        this.percentageLoaded = 0;

        this.completeCallback = _loadCompleteCallback;
        this.loadedImgArr = [];
        this.loader = $('#loading');
        this.backDrop = $('div.load-container');

        TweenLite.set(this.backDrop.show(), {opacity: 1});
        this.loadNext();
    }

    updateLoaderView () {
        this.loader.css( 'height', (this.percentageLoaded*100) +'%' );
    }

    loadNext() {
        setTimeout( ()=>{
            if(this.loadingIndex >= this.imgURLArr.length) {
                TweenLite.to(this.backDrop, 0.4, { autoAlpha: 0, delay: 0.2, ease: Linear.easeNone });
                this.completeCallback();
                return;
            }

            let img = document.createElement("img");
                img.onload = (e)=>{
                    let img = e.target;
                    if( img ) this.loadedImgArr.push(img);
                    this.loadingIndex++;
                    this.percentageLoaded = this.loadingIndex / this.imgURLArr.length;
                    this.updateLoaderView();
                    this.loadNext();
                };

                img.onerror = (e)=>{
                    let img = e.target;
                    this.loadedImgArr.push(null);
                    this.loadFailNum++;
                    this.loadingIndex++;
                    this.percentageLoaded = Math.floor((this.loadingIndex / this.imgURLArr.length) * 100);
                    this.loadNext();
                };
                img.src = this.imgURLArr[this.loadingIndex];
        }, 16);
    }

}

export default PreLoader;